import { getHeaders, getNonJsonHeaders } from '../../../core/api';
import { host } from '../../../config';

export function fetchProfile(id) {
  return fetch(`${host}/api/profile/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}



export function patchProfile(id, payload) {
  return fetch(`${host}/api/profile/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function postSetPassword(id, payload) {
  return fetch(`${host}/api/profile/${id}/password/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function uploadProfileImage(id, acceptedFiles) {
  const formData = new FormData();
  formData.append('custom_image', acceptedFiles[0]);
  return fetch(`${host}/api/profile/${id}/`, {
    method: 'PATCH',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}



// WEBPACK FOOTER //
// src/routes/profile/modules/api.js